






































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import store from 'src/assets/store'
import ModalDialog from 'components/modals/Dialog.vue'
import api from 'src/assets/api/gql'
import StudentGroupUpdate from 'src/graphql/student_group/StudentGroupUpdate.gql'
import ItemShareTeam from 'src/graphql/item_share/ItemShareTeam.gql'
import { Item, StudentGroup, ItemShare, ItemShareRole } from 'src/graphql/types'

@Component({
  components: {
    ModalDialog
  }
})
export default class ItemCourseStudentGroupButtonTeam extends Vue {
  state = store.state
  ItemShareRole = ItemShareRole
  loading: boolean = false
  team: ItemShare[] = []

  @Prop()
  readonly item!: Item

  @Prop()
  readonly group!: StudentGroup

  @Ref()
  readonly dialog!: ModalDialog

  async selectPresenter () {
    this.dialog.show()
    const { data: { itemShareTeam } } = await api.query({
      query: ItemShareTeam,
      variables: {
        id: this.item.id
      }
    })
    this.team = itemShareTeam.nodes as ItemShare[]
  }

  async changePresenter (presenterId: number) {
    this.dialog.hide()
    this.loading = true
    const { data: { updateStudentGroup } } = await api.mutate({
      query: StudentGroupUpdate,
      variables: {
        id: this.group.id,
        data: { presenterId }
      }
    })
    this.loading = false
    if (updateStudentGroup) {
      this.$emit('set', updateStudentGroup.studentGroup)
    }
  }
}
